import { Seo } from "../../components/public/Seo";
import { CtaBand } from "../../components/public/Shared";
import { ServiceMapSection } from "../../components/three/ServiceMap3D";

export default function ServiceAreas() {
  return (
    <>
      <Seo title="Service Area — Perth WA" description="West Face Roofing services all of Perth within 20 km of South Perth — residential and commercial roofing. Based at Coode Street, South Perth WA 6151." path="/service-areas" />
      <section className="pt-32 md:pt-44 pb-4 bg-[#0f1814] text-white relative overflow-hidden wf-grain">
        <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
          <p className="text-[#62B848] font-bold tracking-wide uppercase text-sm mb-4">Service area</p>
          <h1 className="font-display font-black heading-up uppercase tracking-tight text-5xl sm:text-6xl lg:text-7xl leading-none max-w-3xl text-balance">Servicing all of Perth.</h1>
          <p className="mt-6 text-white/70 text-lg max-w-xl leading-relaxed">Within 20 km of South Perth — homes and commercial property right across the metro.</p>
        </div>
      </section>
      <ServiceMapSection />
      <CtaBand />
    </>
  );
}
